import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '热门分类',
    links: [
      { label: '网红塌房', href: '/category/wanghong-tafang' },
      { label: '黑料爆料', href: '/category/heiliao-baoliao' },
      { label: '每日大赛', href: '/category/meiri-dasai' },
      { label: '娱乐八卦', href: '/category/yule-bagua' },
    ],
  },
  {
    title: '快速入口',
    links: [
      { label: '51吃瓜网站入口', href: '/' },
      { label: '51吃瓜在线观看', href: '/category/shipin-remen' },
      { label: '最新吃瓜网站', href: '/category/heiliao-baoliao' },
      { label: '吃瓜网址导航', href: '/' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '口碑评价', href: '/about' },
      { label: '联系我们', href: '/about' },
      { label: '商务合作', href: '/about' },
    ],
  },
  {
    title: '友情链接',
    links: [
      { label: '在线吃瓜', href: '/category/zhibo-chigua' },
      { label: '黑料吃瓜在线', href: '/category/heiliao-baoliao' },
      { label: '51吃瓜官网', href: '/' },
      { label: '51吃瓜视频', href: '/category/shipin-remen' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 mb-12">
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-foreground-900 text-base mb-4">
                <span>{group.title}</span>
              </h4>
              <div className="w-8 h-px bg-secondary-300 mb-4"></div>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-foreground-500 text-sm hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-6 pt-8 border-t border-secondary-200/60">
          <div>
            <div className="flex items-baseline gap-1 mb-2">
              <span className="font-heading text-3xl text-primary-500">吃瓜一线</span>
              <span className="font-heading text-xl text-secondary-400">· 线路一</span>
            </div>
            <div className="w-12 h-px bg-secondary-300 mb-3"></div>
            <p className="text-foreground-500 text-xs leading-relaxed max-w-xs">
              聚合呈现51吃瓜网站入口、在线吃瓜、最新黑料爆料，追踪网红塌房与每日大赛热点。
            </p>
          </div>

          <div className="flex flex-col items-start sm:items-end gap-2">
            <p className="text-foreground-400 text-xs whitespace-nowrap">
              &copy; 2026 吃瓜一线 线路一 · 版权所有
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors duration-200 cursor-pointer" aria-label="抖音" rel="nofollow">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}